module.exports = __webpack_public_path__ + "img/icon_accuracy.437d70f6.svg";